module.exports = __webpack_public_path__ + "static/media/4.61f0ab5d.png";